import { Helmet } from "react-helmet";
import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense, use, useEffect, useState } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
import carIcon from '../../asstes/images/car-icon.svg';
import { Heading, Img, Button, Text, Switch } from "../../components";
import CarDetails from 'components/CarDetails';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ProposalDateRow from "../../components/ProposalDateRow";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
/** ➋ קומפוננטת שדה-טופס קטנה (אפשר לשים בקובץ נפרד) */
import SendNewOfferColumncar10660x from "../../components/SendNewOfferColumncar10660x";
import CarCardTemplate from 'components/CarCardTemplate';
import UnderlineInput from "components/UnderlineInput";
import SendNewOfferForm from "components/SendNewOfferForm";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { he } from "date-fns/locale";   
registerLocale("he", he);  
export default function 

LeftSendOffer({
  isRejectedOrApproved,
  onClose,
  car,
  currentUser,
  offer,
  onUpdateOffer
}) {
  return (
    <div
      className="my-ads-dealer left-send-offer flex w-[19%] flex-col gap-3 rounded-[24px] bg-secondary-primary_white  shadow-xs md:w-full sm:p-4 overflow-y-auto overflow-x-hidden"
      style={{
        position: "fixed",
        top: "1rem",
        bottom: "1rem",
        left: "2rem",
        boxSizing: "border-box",
      }}
    >
      <div className="w-full flex justify-center">
        <div className="w-full">
          <SendNewOfferForm
            variant="panel"
            isRejectedOrApproved={isRejectedOrApproved}
            onClose={onClose}
            car={car}
            currentUser={currentUser}
            offer={offer}
            onUpdateOffer={onUpdateOffer}
          />
        </div>
      </div>
    </div>
  );
}
